export default {
  getSaitiInfo: (state, data) => {
    state.sitiInfo = data
  },

  getNewsInfo: (state, data) => {
    state.newsInfo = data
  },

  setSiteLang(state, lang) {
    state.currentLanguge = lang
  },

  setSiteMsgnum(state, msgnum) {
    state.msgnum = msgnum
  },

  SET_COMPETITION_INTRODUCTION(state, data) {
    state.competitionIntroduction = data
  },

  setArticles(state, articles) {
    state.articles = articles
  },

  setModalStates(state, modalStates) {
    state.modalStates = {
      ...state.modalStates,
      ...modalStates
    }
  },

  updateModalState(state, { key, value }) {
    state.modalStates[key] = value
  },

  setCurrentTime(state, time) {
    state.currentTime = time
  },

  setSaitiStatusCont(state, saitiStatusCont) {
    state.saitiStatusCont = saitiStatusCont
  }
}
